import { render } from "./EducationSection.vue?vue&type=template&id=b157d0a6&scoped=true"
import script from "./EducationSection.vue?vue&type=script&lang=js"
export * from "./EducationSection.vue?vue&type=script&lang=js"

import "./EducationSection.vue?vue&type=style&index=0&id=b157d0a6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b157d0a6"]])

export default __exports__